export const buildEnvironment = {
"buildId":"427227",
"buildDate":"2024-05-09T21:04:10.933Z",
"buildTimeStamp":1715288650933,
"ngVersion":"15.0.3",
"version":"7.0.5111",
"api":"21.12",
"environment":"prod",
"production":true
};